var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1290,
    height: 123,
    viewBox: "0 0 1290 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.973 22.1531H438.53V100.481H404.973V78.0764H416.101V89.1917H427.402V66.7876H393.845V100.307H382.717V66.7876H382.544V55.6724H382.717V22.1531H393.845V55.6724H427.402V33.2683H416.101V44.3836H404.973V22.1531ZM483.389 100.481H449.832V22.1531H483.389V44.5572H472.261V33.2683H460.959V55.6724H494.517V22.1531H505.645V55.6724H505.819V66.7876H505.645V100.307H494.517V66.7876H460.959V89.1917H472.261V78.0764H483.389V100.481Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1075.97 22.1531H1109.53V100.481H1075.97V78.0764H1087.1V89.1917H1098.4V66.7876H1064.84V100.307H1053.72V66.7876H1053.54V55.6724H1053.72V22.1531H1064.84V55.6724H1098.4V33.2683H1087.1V44.3836H1075.97V22.1531ZM1154.39 100.481H1120.83V22.1531H1154.39V44.5572H1143.26V33.2683H1131.96V55.6724H1165.52V22.1531H1176.64V55.6724H1176.82V66.7876H1176.64V100.307H1165.52V66.7876H1131.96V89.1917H1143.26V78.0764H1154.39V100.481Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M539.154 22.1531H572.711V100.481H539.154V78.0764H550.282V89.1917H561.584V66.7876H528.027V100.307H516.898V66.7876H516.725V55.6724H516.898V22.1531H528.027V55.6724H561.584V33.2683H550.282V44.3836H539.154V22.1531ZM617.571 100.481H584.013V22.1531H617.571V44.5572H606.442V33.2683H595.141V55.6724H628.698V22.1531H639.826V55.6724H640V66.7876H639.826V100.307H628.698V66.7876H595.141V89.1917H606.442V78.0764H617.571V100.481Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.15 22.1531H1243.71V100.481H1210.15V78.0764H1221.28V89.1917H1232.58V66.7876H1199.03V100.307H1187.9V66.7876H1187.72V55.6724H1187.9V22.1531H1199.03V55.6724H1232.58V33.2683H1221.28V44.3836H1210.15V22.1531ZM1288.57 100.481H1255.01V22.1531H1288.57V44.5572H1277.44V33.2683H1266.14V55.6724H1299.7V22.1531H1310.83V55.6724H1311V66.7876H1310.83V100.307H1299.7V66.7876H1266.14V89.1917H1277.44V78.0764H1288.57V100.481Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.611 22.1528H170.167V100.48H136.611V78.0762H147.738V89.1914H159.04V66.7873H125.483V100.307H114.354V66.7873H114.181V55.6722H114.354V22.1528H125.483V55.6722H159.04V33.2681H147.738V44.3833H136.611V22.1528ZM215.027 100.48H181.469V22.1528H215.027V44.5569H203.898V33.2681H192.597V55.6722H226.155V22.1528H237.282V55.6722H237.456V66.7873H237.282V100.307H226.155V66.7873H192.597V89.1914H203.898V78.0762H215.027V100.48Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M807.61 22.1528H841.167V100.48H807.61V78.0762H818.738V89.1914H830.04V66.7873H796.483V100.307H785.354V66.7873H785.181V55.6722H785.354V22.1528H796.483V55.6722H830.04V33.2681H818.738V44.3833H807.61V22.1528ZM886.027 100.48H852.469V22.1528H886.027V44.5569H874.898V33.2681H863.597V55.6722H897.154V22.1528H908.282V55.6722H908.456V66.7873H908.282V100.307H897.154V66.7873H863.597V89.1914H874.898V78.0762H886.027V100.48Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.792 22.1528H304.349V100.48H270.792V78.0762H281.919V89.1914H293.221V66.7873H259.664V100.307H248.536V66.7873H248.363V55.6722H248.536V22.1528H259.664V55.6722H293.221V33.2681H281.919V44.3833H270.792V22.1528ZM349.208 100.48H315.65V22.1528H349.208V44.5569H338.08V33.2681H326.778V55.6722H360.336V22.1528H371.463V55.6722H371.637V66.7873H371.463V100.307H360.336V66.7873H326.778V89.1914H338.08V78.0762H349.208V100.48Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941.791 22.1528H975.348V100.48H941.791V78.0762H952.919V89.1914H964.22V66.7873H930.663V100.307H919.535V66.7873H919.362V55.6722H919.535V22.1528H930.663V55.6722H964.22V33.2681H952.919V44.3833H941.791V22.1528ZM1020.21 100.48H986.65V22.1528H1020.21V44.5569H1009.08V33.2681H997.777V55.6722H1031.33V22.1528H1042.46V55.6722H1042.64V66.7873H1042.46V100.307H1031.33V66.7873H997.777V89.1914H1009.08V78.0762H1020.21V100.48Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42928 22.1528H35.9862V100.48H2.42928V78.0762H13.5569V89.1914H24.8586V66.7873H-8.69834V100.307H-19.8268V66.7873H-20V55.6722H-19.8268V22.1528H-8.69834V55.6722H24.8586V33.2681H13.5569V44.3833H2.42928V22.1528ZM80.8456 100.48H47.2878V22.1528H80.8456V44.5569H69.7171V33.2681H58.4155V55.6722H91.9732V22.1528H103.101V55.6722H103.275V66.7873H103.101V100.307H91.9732V66.7873H58.4155V89.1914H69.7171V78.0762H80.8456V100.48Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M673.429 22.1528H706.986V100.48H673.429V78.0762H684.557V89.1914H695.859V66.7873H662.302V100.307H651.173V66.7873H651V55.6722H651.173V22.1528H662.302V55.6722H695.859V33.2681H684.557V44.3833H673.429V22.1528ZM751.846 100.48H718.288V22.1528H751.846V44.5569H740.717V33.2681H729.415V55.6722H762.973V22.1528H774.101V55.6722H774.275V66.7873H774.101V100.307H762.973V66.7873H729.415V89.1914H740.717V78.0762H751.846V100.48Z",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1311,
    y: 112,
    width: 11,
    height: 1331,
    transform: "rotate(90 1311 112)",
    fill: "#bbbbbb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1311,
    width: 11,
    height: 1331,
    transform: "rotate(90 1311 0)",
    fill: "#bbbbbb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.99b5c4c87d82160cb452f0b5c8e7f925.svg";
export { ForwardRef as ReactComponent };